import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';

import * as DashboardActions from '../actions/dashboardActions';

import * as classes from './TimeFrameSelector.module.css';

const TimeFrameSelector = ({
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    isCurrent,
    setDashboardTimeframeEnd,
    setDashboardTimeframeStart,
    ...props
}) => {
    const [start, setStart] = useState();
    const [end, setEnd] = useState();

    useEffect(() => {
        const initializeTime = () => {
            const startTime = moment(dashboardStartTimeStamp).format();
            let endTime;

            moment(startTime).add(4, 'hours') >= moment(endTime) ?
                endTime = moment(endTime).format()
                :   
                endTime = moment(dashboardStartTimeStamp).add(4, 'hours').format();

            setTimeframe(startTime, endTime);
            setStart(moment(startTime).format());
            setEnd(moment(endTime).format());
        };

        if (dashboardStartTimeStamp) initializeTime();
    }, [dashboardStartTimeStamp]);

    const setTimeframe = (start, end) => {
        Promise.all([
            setDashboardTimeframeStart(moment(start)),
            setDashboardTimeframeEnd(moment(end))
        ].map(p => p.catch(err => err)));
    };

    const renderTimeRange = () => {
        if (isCurrent) return moment(dashboardEndTimeStamp).format('YYYY-MM-DD h:mm A');

        return `${moment(start).format('YYYY-MM-DD h:mm A')} - ${moment(end).format('YYYY-MM-DD h:mm A')}`;
    };

    const handleGoBack = () => {
        if (isBackDisabled()) return;

        let startTime = moment(start).subtract(4, 'hours').format();
        const endTime = moment(start).format();

        if (startTime < moment(dashboardStartTimeStamp)) {
            startTime = moment(dashboardStartTimeStamp).format();
        }

        setTimeframe(startTime, endTime);
        setStart(moment(startTime).format());
        setEnd(moment(endTime).format());
    };

    const handleGoForward = () => {
        if (isForwardDisabled()) return;

        let startTime = moment(start).add(4, 'hours').format();
        let endTime = moment(end).add(4, 'hours').format();

        if (moment(endTime) > moment(dashboardEndTimeStamp)) {
            startTime = moment(start).format();
            endTime = moment(dashboardEndTimeStamp).format();
        }

        setTimeframe(startTime, endTime);
        setStart(moment(startTime).format());
        setEnd(moment(endTime).format());
    };

    const isBackDisabled = () => {
        if (isCurrent) return true;
        if (moment(start) <= moment(dashboardStartTimeStamp)) return true;

        return false;
    };

    const isForwardDisabled = () => {
        if (isCurrent) return true;
        if (moment(end).seconds(0).milliseconds(0) >= moment(dashboardEndTimeStamp).seconds(0).milliseconds(0)) return true;

        return false;
    };

    return (
        <div className={classes.Container}>
            <div role="none" onClick={handleGoBack} className={isBackDisabled() ? classes.ButtonDisabled : classes.Button}>
                <span className="material-icons-outlined md-18">
                    chevron_left
                </span>
            </div>
            <div className={classes.TimeFrame}>
                <span>
                    {renderTimeRange()}
                </span>
            </div>
            <div role="none" onClick={handleGoForward} className={isForwardDisabled() ? classes.ButtonDisabled : classes.Button}>
                <span className="material-icons-outlined md-18">
                    chevron_right
                </span>
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default connect(null, mapDispatchToProps)(TimeFrameSelector);
